import { Container, Row, Col, ButtonGroup, Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket, faGaugeHigh } from '@fortawesome/free-solid-svg-icons';
import logoRT from "../../assets/img/logo-rt.png"; 

function Footer() {
  

  return (
    <>

 <footer className="rtds-footer rtds-border-t rtds-border-gray-01">
        <div className="portlet-boundary portlet-boundary_com_liferay_journal_content_web_portlet_JournalContentPortlet_  portlet-static portlet-static-end portlet-barebone portlet-journal-content " id="p_p_id_com_liferay_journal_content_web_portlet_JournalContentPortlet_INSTANCE__site_footer_2_">
          <span id="p_com_liferay_journal_content_web_portlet_JournalContentPortlet_INSTANCE__site_footer_2"></span>
          <section className="portlet" id="portlet_com_liferay_journal_content_web_portlet_JournalContentPortlet_INSTANCE__site_footer_2">
            <div className="portlet-content">
              <div className="autofit-float autofit-row portlet-header">
                <div className="autofit-col autofit-col-end">
                  <div className="autofit-section">
                    <div className="visible-interaction"></div>
                  </div>
                </div>
              </div>
              <div className=" portlet-content-container">
                <div className="portlet-body">
                  <div className="" data-fragments-editor-item-id="10108-19298877" data-fragments-editor-item-type="fragments-editor-mapped-item">
                    <div className="journal-content-article " data-analytics-asset-id="19298875" data-analytics-asset-title="Footer 2" data-analytics-asset-type="web-content" data-analytics-web-content-resource-pk="19298877">
                      <div className="rtds-logos-area">
                        <div className="rtds-container rtds-py-6 md:rtds-py-8 rtds-space-y-6">
                          <h2 className="rtds-content-02 rtds-text-base md:rtds-text-lg rtds-font-bold">Siti collegati</h2>
                          <div className="rtds-grid md:rtds-flex rtds-gap-4 md:rtds-items-center">
                            <div className="rtds-flex rtds-flex-wrap rtds-gap-4 md:rtds-gap-6 rtds-items-center lg:rtds-gap-12">
                              <a className="rtds-site-logo" href="https://www.regione.toscana.it/speciali/muoversi-in-toscana">
                                <img alt="Muoversi in Toscana" className="rtds-w-full rtds-h-full rtds-object-contain rtds-object-left-top" height="24" src="./images/muoversi-in-toscana.png" width="111"/>
                              </a>
                              <a className="rtds-site-logo" href="http://www.toscana-accessibile.it/home">
                                <img alt="Toscana Accessibile" className="rtds-w-full rtds-h-full rtds-object-contain rtds-object-left-top" height="22" src="./images/toscana-accessibile.png" srcSet="./images/toscana-accessibile.png 1x, ./images/toscana-accessibile@2x.png 2x" width="142"/>
                              </a>
                              <a className="rtds-site-logo" href="https://giovanisi.it/">
                                <img alt="GiovaniSì" className="rtds-w-full rtds-h-full rtds-object-contain rtds-object-left-top" height="28" src="./images/giovanisi.png" srcSet="./images/giovanisi.png 1x, ./images/giovanisi@2x.png 2x"  width="94"/>
                              </a>
                              <a className="rtds-site-logo" href="https://digitale.toscana.it/">
                                <img alt="Toscana Digitale" className="rtds-w-full rtds-h-full rtds-object-contain rtds-object-left-top" height="24" src="./images/toscana-digitale.png" srcSet="./images/toscana-digitale.png 1x, ./images/toscana-digitale@2x.png 2x" width="129"/>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*<div className="rtds-footer__navigation-row rtds-container rtds-grid rtds-gap-x-10 rtds-gap-y-4 md:rtds-flex">
                       
                        <div className="rtds-grid rtds-gap-6 md:rtds-gap-3 md:rtds-flex-1">
                        
                          <nav aria-label="Contatti e utilità" className="rtds-pb-4 -rtds-ml-4">
                            <ul className="rtds-grid md:rtds-flex rtds-gap-y-3 md:rtds-gap-y-4 rtds-flex-wrap">
                              <li className="rtds-group md:rtds-border-r md:rtds-border-gray-01 md:last:rtds-border-r-0">
                                <a className="rtds-link rtds-px-4 rtds-py-2 rtds-text-sm rtds-content-02 rtds-font-bold rtds-uppercase" href="/uffici">UFFICI</a>
                              </li>
                              <li className="rtds-group md:rtds-border-r md:rtds-border-gray-01 md:last:rtds-border-r-0">
                                <a className="rtds-link rtds-px-4 rtds-py-2 rtds-text-sm rtds-content-02 rtds-font-bold rtds-uppercase" href="/urp">URP</a>
                              </li>
                              <li className="rtds-group md:rtds-border-r md:rtds-border-gray-01 md:last:rtds-border-r-0">
                                <a className="rtds-link rtds-px-4 rtds-py-2 rtds-text-sm rtds-content-02 rtds-font-bold rtds-uppercase" href="/posta-elettronica-certificata-pec">PEC</a>
                              </li>
                              <li className="rtds-group md:rtds-border-r md:rtds-border-gray-01 md:last:rtds-border-r-0">
                                <a className="rtds-link rtds-px-4 rtds-py-2 rtds-text-sm rtds-content-02 rtds-font-bold rtds-uppercase" href="/mappa">MAPPA DEL SITO</a>
                              </li>
                              <li className="rtds-group md:rtds-border-r md:rtds-border-gray-01 md:last:rtds-border-r-0">
                                <a className="rtds-link rtds-px-4 rtds-py-2 rtds-text-sm rtds-content-02 rtds-font-bold rtds-uppercase" href="https://intranet.regione.toscana.it/">INTRANET</a>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>*/}
                      <div className="rtds-border-t rtds-border-gray-01">
                        <div className="rtds-container">
                          
                          <nav aria-label="Altre informazioni" className="-rtds-ml-4 rtds-py-4 md:rtds-py-6">
                            <ul className="rtds-grid md:rtds-flex rtds-gap-y-3 md:rtds-gap-y-4 rtds-flex-wrap">
                              <li className="rtds-group">
                                <a className="rtds-link rtds-px-4 rtds-py-2 rtds-text-sm rtds-content-03 rtds-font-bold" href="https://www.regione.toscana.it/-/accessibilita-e-uso-del-sito">Accessibilità</a>
                              </li>
                              <li className="rtds-group">
                                <a className="rtds-link rtds-px-4 rtds-py-2 rtds-text-sm rtds-content-03 rtds-font-bold" href="https://www.regione.toscana.it/note-legali">Note legali</a>
                              </li>
                              <li className="rtds-group">
                                <a className="rtds-link rtds-px-4 rtds-py-2 rtds-text-sm rtds-content-03 rtds-font-bold" href="https://www.regione.toscana.it/regione/amministrazione-trasparente">Amministrazione Trasparente</a>
                              </li>
                              <li className="rtds-group">
                                <a className="rtds-link rtds-px-4 rtds-py-2 rtds-text-sm rtds-content-03 rtds-font-bold" href="https://www.regione.toscana.it/pubblicità-legale">Pubblicità legale</a>
                              </li>
                              <li className="rtds-group">
                                <a className="rtds-link rtds-px-4 rtds-py-2 rtds-text-sm rtds-content-03 rtds-font-bold" href="https://www.regione.toscana.it/privacy">Privacy</a>
                              </li>
                              <li className="rtds-group">
                                <a className="rtds-link rtds-px-4 rtds-py-2 rtds-text-sm rtds-content-03 rtds-font-bold" href="https://www.regione.toscana.it/data-protection-officer">DPO/RDP</a>
                              </li>
                              <li className="rtds-group">
                                <a className="rtds-link rtds-px-4 rtds-py-2 rtds-text-sm rtds-content-03 rtds-font-bold" href="https://www.regione.toscana.it/redazione-web">Redazione web</a>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
       
        <div className="rtds-footer__bottom-bar">
          <div className="rtds-container rtds-grid rtds-gap-6 md:rtds-flex rtds-items-center rtds-justify-between">
            <div className="rtds-footer__bottom-bar-left">
             
              <div className="-rtds-ml-4 rtds-flex rtds-gap-y-3 rtds-gap-x-5 md:rtds-gap-y-1 rtds-flex-wrap rtds-content-01">
                <small className="rtds-py-1 rtds-px-4 md:rtds-py-4 rtds-content-01 rtds-text-sm rtds-font-bold">Partita IVA 01386030488</small>
              </div>
            </div>
            <div className="rtds-footer__bottom-bar-right rtds-px-2 md:rtds-px-0">
             
              <div className="rtds-site-logo rtds-w-40 rtds-h-auto md:rtds-w-44 lg:rtds-w-auto">
                <img className="rtds-w-full rtds-h-full rtds-object-contain rtds-object-left-top" src="./images/regione-toscana-logo-footer.png" srcSet="./images/regione-toscana-logo-footer.png 1x, ./images/regione-toscana-logo-footer@2x.png 2x" alt="Regione Toscana" width="220" height="65" />
              </div>
            </div>
          </div>
        </div>
      </footer>

</>
);
}

export default Footer;